import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {
    Component
} from "../../../sedestral/framework/interface/component/Component";
import {
    ICommunitySEOKeywordsSearchOutgoing
} from "../../../models/community/seo/keywords/ICommunitySEOKeywordsSearchOutgoing";
import {ICommunitySEOKeywordsIncoming} from "../../../models/community/seo/keywords/ICommunitySEOKeywordsIncoming";
import {
    ICommunitySEORankingIndividualsPositioningModel
} from "../../../models/community/seo/ranking/ICommunitySEORankingIndividualsPositioningModel";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {Services} from "../../Services";
import {
    ICommunitySEOKeywordsPresentationOutgoing
} from "../../../models/community/seo/keywords/ICommunitySEOKeywordsPresentationOutgoing";
import {
    ICommunitySEORankingKeywordsOverviewModel
} from "../../../models/community/seo/ranking/ICommunitySEORankingKeywordsOverviewModel";
import {IPaginationOutgoing} from "../../../models/pagination/IPaginationOutgoing";
import {dateToUTCCompare} from "../../../sedestral/framework/utilities/DateToUTCCompare";
import {ICommunitySEOKeyword} from "../../../models/community/seo/keywords/keyword/ICommunitySEOKeyword";
import {
    ICommunitySEORankingUrlsPositioningIncoming
} from "../../../models/community/seo/ranking/ICommunitySEORankingUrlsPositioningIncoming";
import {
    ICommunitySEORankingKeywordsByUrlIncoming
} from "../../../models/community/seo/ranking/ICommunitySEORankingKeywordsByUrlIncoming";

export class CommunityKeywordsService {

    public static dispose(): void {

    }

    public static init(): void {
    }

    public static async getKeywordsSite(search: ICommunitySEOKeywordsSearchOutgoing, component: Component): Promise<ICommunitySEOKeywordsIncoming> {
        Services.handleErrors(component, [
            {status: HttpStatus.BAD_REQUEST, message: "none"}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/keywords/site`, search, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async searchKeywords(name: string, search: ICommunitySEOKeywordsSearchOutgoing, component?: Component): Promise<[HttpStatus, ICommunitySEOKeywordsIncoming]> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/keywords/search/${name}`, search, component);
        return {status: request?.status, ...request?.data};
    }

    public static async searchKeywordsHistory(communityId: string, component?: Component): Promise<ICommunitySEOKeywordsPresentationOutgoing[]> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"}
        ]);

        let request = await Network.get(ProductType.COMMUNITY, `/community/keywords/search/history/${communityId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getRankingOverview(communityId: string, dateStart: number, dateEnd: number, component?: INetworkComponent, autoPeriod?: boolean): Promise<ICommunitySEORankingKeywordsOverviewModel> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"}
        ]);

        let request = await Network.get(ProductType.COMMUNITY, `/community/ranking/overview/${communityId}/${dateToUTCCompare(dateStart, false)}/${dateToUTCCompare(dateEnd, true)}${autoPeriod ? "?autoPeriod=true" : ""}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }

        return undefined;
    }

    public static async getIndividualsPositioning(id: string, search: ICommunitySEOKeywordsSearchOutgoing, component?: Component): Promise<ICommunitySEORankingIndividualsPositioningModel> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/ranking/individualsPositioning/${id}`, search, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getKeywordsByUrl(communityId: string, url: string, component?: INetworkComponent): Promise<ICommunitySEORankingKeywordsByUrlIncoming> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"}
        ]);

        let request = await Network.get(ProductType.COMMUNITY, `/community/ranking/keywordsByUrl/${communityId}?url=${encodeURIComponent(url)}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async getUrlsPositioning(communityId: string, search: ICommunitySEOKeywordsSearchOutgoing, component?: Component): Promise<ICommunitySEORankingUrlsPositioningIncoming> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/ranking/urlsPositioning/${communityId}`, search, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

}